import React, {useEffect, useState} from 'react';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import customFonts from '../src/fontsPDF/fonts';
import {useAuth} from './AuthContext';
import axios from "axios";
import background from '../src/vfs';
import headerImage from '../src/headerImage';
import he from 'he';
import API_URL from './config/apiConfig';
import Swal from "sweetalert2";

// Vérifier que pdfFonts est bien défini et a la propriété vfs
if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else {
    console.warn("pdfFonts.pdfMake.vfs n'est pas défini, utilisation d'un objet vide");
    pdfMake.vfs = {};
}

// Ajouter notre image d'arrière-plan si pdfMake.vfs est défini
if (pdfMake.vfs) {
    pdfMake.vfs['background.jpg'] = background.background;
} else {
    console.error("pdfMake.vfs n'est pas défini, impossible d'ajouter l'image d'arrière-plan");
}


const PdfGenerator = ({ messages, setShowForm, sentImageUrls= [], setShowModal, setIsOver }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [buttonStatus, setButtonStatus] = useState(false);
    const [isDownloaded, setIsDownloaded] = useState(false);

    const {authToken} = useAuth();
    const userName = authToken.userName;
    const userId = authToken.userId;
    const userEmail = authToken.userEmail;

    const handlePdfGenerated = async (userId) => {
        try {
            const response = await axios.post(`${API_URL}/update-pdf-status`, { userId });
            console.log(response.data);  // PDF status updated
        } catch (error) {
            console.error('Error updating PDF status:', error);
        }
    };


    useEffect(() => {
        const phraseSpecifique = 'Début rapport';
        const messageContientPhrase = messages.some(message =>
            typeof message.content === 'string' && message.content.includes(phraseSpecifique)
        );

        setButtonStatus(messageContientPhrase);


        if (messageContientPhrase && !isDownloaded) {
            console.log("début rapport");
            setIsLoading(true);
            setIsDownloaded(true); // Marquer comme téléchargé pour éviter les générations multiples
            generatePdf(); // Génération du premier PDF
            handlePdfGenerated(userId); // Mettre à jour le statut du PDF sur le serveur
            setIsDownloaded(true);
        }

        // Afficher le modal uniquement après que tout est téléchargé
        if (isDownloaded && !isLoading) {
            // setShowModal(true);
            Swal.fire({
                title: "Félicitations !",
                html: '<div style="font-family: \'Noto_Sans\',serif "> Votre rapport a été généré</div> ' +
                    '<div style="font-family: \'Noto_Sans\',serif ">Vous pouvez le retrouver dans le dossier "Téléchargement" de votre ordinateur.</div>',
                icon: "success",
                draggable: true
                });
            if (setIsOver) setIsOver(true);
        }
    }, [messages, isDownloaded, isLoading]);



    /**
     * Génération du PDF sur serveur pour gestionnaire
     * @returns {Promise<void>}
     */
    const generatePdf = async () => {
        setIsLoading(true);

        const cleanText = (text) => {
            if (!text || typeof text !== 'string') return text;

            let decodedText = he.decode(text)
                .replace(/\*\*/g, '')              // Supprime les marqueurs de gras Markdown
                .replace(/([0-9]+)( ?)cm/g, '$1 cm') // Ajoute un espace entre les nombres et "cm"
                .replace(/cm([a-zA-Z])/g, 'cm $1')  // Ajoute un espace après "cm" suivi d'une lettre
                .replace(/([0-9]+)°/g, '$1 °')      // Ajoute un espace entre les nombres et le symbole degré
                .replace(/\u2022/g, '•')            // Remplace les puces Unicode par des puces simples
                .replace(/\u2013/g, '-')            // Remplace les tirets cadratin par des tirets simples
                .replace(/\u2014/g, '-')            // Remplace les tirets demi-cadratin par des tirets simples
                .replace(/;/g, '.') // Remplace les points-virgules par des points
            return decodedText
                .trim();                           // Supprime les espaces inutiles au début et à la fin
        }

        const lastMessages = messages.slice(Math.max(messages.length - 25, 0));
        let globalContentPreRapport = '';
        //cherche le contenu du pré-rapport dans les messages
        lastMessages.forEach((message) => {
            // Assure-toi que `message.content` est une chaîne de caractères avant de la diviser
            if (typeof message.content === 'string') {
                const messageLines = message.content.split("\n").map(cleanText);
                let isPreRapport = false;
                const debutRapport = 'Début rapport';
                const finRapport = 'Fin rapport';
                let contentPreRapport = '';

                messageLines.forEach(line => {
                    if (line.includes(debutRapport)) {
                        isPreRapport = true;
                        setButtonStatus(true);
                    } else if (line.includes(finRapport)) {
                        isPreRapport = false;
                        // Pas besoin de `return` ici car nous voulons continuer à lire les lignes du message actuel
                    } else if (isPreRapport && !line.includes(finRapport)) {
                        contentPreRapport += line + '\n';
                    }
                });

                // Si du contenu de pré-rapport a été trouvé dans le message actuel, ajoute-le au contenu global de pré-rapport
                if (contentPreRapport) {
                    globalContentPreRapport += contentPreRapport + '\n'; // Sépare les contenus de pré-rapport de différents messages par une nouvelle ligne
                }
            }
        });

        const titres = [
            "I. MANDANT ET INFORMATIONS INITIALES",
            "II. HISTORIQUE",
            "III. CONSTATATIONS",
            "IV. DOMMAGES CAUSES ET CONSÉQUENCES",
            "V. RESPONSABILITÉS ET FONDEMENTS",
            "VI. CONCLUSION",
            "VII. SUITES À DONNER",
        ];


        const regexPattern = `(${titres.map(titre => `\\b${titre}\\b`).join('|')})`;
        const regex = new RegExp(regexPattern, 'gm');

        const partiesRapport = globalContentPreRapport.split(regex);

        const convertImageToDataUrl = (url, quality = 0.8) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                img.onload = function () {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.height = this.naturalHeight;
                    canvas.width = this.naturalWidth;
                    ctx.drawImage(this, 0, 0);
                    const dataURL = canvas.toDataURL('image/jpeg', quality);
                    resolve(dataURL);
                };
                img.onerror = reject;
                img.src = url;
            });
        };

        const date = new Date();
        const formatedDate = date.toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });

        const docDefinition = {
            footer: {
                columns: [
                    { text: 'Siège social : Chemin de Villeneuve 66200 MONTESCOT -' +
                            'Courriel : contact@aiexpetys.fr',
                        alignment: 'center',
                        margin: [40, 0, 40, 0],
                        fontSize: 10,
                        color: 'gray'
                    },
                ]
            },
            content: [
                {
                    image: headerImage.headerImage,
                    width: 100,
                    alignment: 'center',
                    margin: [0,0,0,20]
                },
                {
                    text: `Rapport d'expertise du ${formatedDate}`,
                    style: 'header'
                },
                {
                    text: globalContentPreRapport,
                    lineHeight: 1.5,
                    alignment: 'justify',
                    margin: [50, 20, 40, 10]
                },
            ],
            styles: {
                header: {
                    fontSize: 20,
                    bold: true,
                    alignment: 'center',
                    margin: [40, 0, 40, 20],
                    decoration: 'underline'
                },
                tableHeader: {
                    fontSize: 16,
                    bold: true
                },
                tableExample: {
                    margin: [0, 30, 0, 15]
                },
                Title: {
                    fontSize: 15,
                    bold: true,
                    decoration: 'underline',
                    margin: [40, 20, 40, 10]
                },
                image: {
                    margin: [0, 20, 0, 20],
                    lineHeight: 1.5,
                    alignment: 'center'
                },
            },
            userInfo: {
                userName: userName,
                userId: userId,
                userEmail: userEmail
            }
        };

        // Traitement des images
        let dataUrls = [];
        if (sentImageUrls.length > 0) {
            try {
                dataUrls = await Promise.all(sentImageUrls.map(url => convertImageToDataUrl(url)));
                const images = dataUrls.map(url => ({
                    image: url,
                    width: 300,
                    style: 'image'
                }));
                docDefinition.content.push(...images);
            } catch (error) {
                console.error("Erreur lors de la conversion des images:", error);
                // Continuer malgré l'erreur
            }
        }

        // Deux opérations indépendantes

        // 1. Générer et télécharger le PDF côté client
        try {
            if (pdfMake && typeof pdfMake.createPdf === 'function') {
                pdfMake.createPdf(docDefinition).download(`prérapport-${userName}.pdf`);
                console.log("PDF généré et téléchargé localement avec succès");
            } else {
                console.error("pdfMake n'est pas correctement initialisé pour la génération locale");
            }
        } catch (clientError) {
            console.error("Erreur lors de la génération locale du PDF:", clientError);
            // Ne pas empêcher l'envoi au serveur si la génération locale échoue
        }

        // 2. Envoyer au serveur pour traitement
        try {
            // Pour éviter les problèmes de polices sur le serveur, nous allons générer le PDF localement
            // et l'envoyer sous forme de données brutes plutôt que d'envoyer la définition du document
            if (pdfMake && typeof pdfMake.createPdf === 'function') {
                // Créer le PDF et l'obtenir sous forme de données binaires
                const pdfDocGenerator = pdfMake.createPdf(docDefinition);

                pdfDocGenerator.getBase64(async (base64) => {
                    try {
                        // Créer un objet simple contenant les données du PDF et les métadonnées
                        const pdfData = {
                            pdfData: base64,
                            userInfo: {
                                userName: userName,
                                userId: userId,
                                userEmail: userEmail
                            }
                        };

                        // Envoyer les données au serveur
                        const response = await fetch(`${API_URL}/pdf`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(pdfData)
                        });

                        if (!response.ok) {
                            const errorText = await response.text();
                            console.error("Réponse serveur non valide:", errorText);
                            throw new Error("Erreur lors de l'envoi du PDF au serveur");
                        }

                        console.log("PDF généré localement et envoyé au serveur avec succès");
                    } catch (error) {
                        console.error("Erreur lors de l'envoi du PDF au serveur:", error);
                    }
                });
            } else {
                console.error("pdfMake n'est pas correctement initialisé pour générer le PDF");
            }
        } catch (serverError) {
            console.error("Erreur lors de la préparation de l'envoi du PDF au serveur:", serverError);
        }

        // Fin du processus quel que soit le résultat des opérations individuelles
        setIsLoading(false);
        console.log("Processus de génération PDF terminé");
    };

    return (
        <div className="">
            <button
                className=""
                onClick={generatePdf}
                disabled={isLoading}>
                <svg className='w-9 h-9 absolute bottom-7 left-[74px] '
                     width="800px"
                     height="800px"
                     viewBox="0 0 512 512"
                     xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fillRule="evenodd">
                        <g fill={isLoading ? "#a0a0a0" : "#2d547d"}>
                            <path
                                d="M 312.32,165.76 285.01333,132.90667 192,210.56 V 0 H 149.33333 V 210.56 L 56.32,132.90667 29.013333,165.76 170.66667,283.73333 Z M 0,341.33333 H 341.33333 V 384 H 0 Z"/>
                        </g>
                    </g>
                </svg>
                {isLoading && (
                    <div className="spinner absolute bottom-7 left-[74px] w-9 h-9 border-4 border-t-4 border-gray-200 rounded-full animate-spin"></div>
                )}
            </button>
        </div>
    );
};

export default PdfGenerator;